const Main = (resolve) => require(["@/components/main/Main.vue"], resolve);
const Main1 = (resolve) => require(["@/components/main/Main1.vue"], resolve);
const Main3 = (resolve) => require(["@/components/main/Main3.vue"], resolve);
const CRM = (resolve) => require(["@/App.vue"], resolve);
const shopMain = (resolve) =>
    require(["@/components/main/shopMain.vue"], resolve);

const productMain = (resolve) =>
    require(["@/module/quickorder/productMain.vue"], resolve);

//主页
const Home = (resolve) => require(["@/module/home/Home.vue"], resolve);
const Home1 = (resolve) => require(["@/module/home/Home1.vue"], resolve);

const EditApply = (resolve) =>
    require(["@/module/home/editApply.vue"], resolve);

//消息
const Message = (resolve) =>
    require(["@/module/message/messageList.vue"], resolve);

//分类
const MenuList = (resolve) => require(["@/module/menu/MenuList.vue"], resolve);
//公告管理
const NoticeList = (resolve) =>
    require(["@/module/notice/noticeList.vue"], resolve);
const NoticeView = (resolve) =>
    require(["@/module/notice/noticeView.vue"], resolve);

// 培训服务通知函
const TrainingnoticeList = (resolve) =>
    require(["@/module/trainingnotice/trainingnoticeList.vue"], resolve);
const TrainingnoticeView = (resolve) =>
    require(["@/module/trainingnotice/trainingnoticeView.vue"], resolve);

// 订单收藏
const CollectView = (resolve) =>
    require(["@/module/collect/CollectView.vue"], resolve);
//订单管理
const OrderChannel = (resolve) =>
    require(["@/module/order/orderchannelList.vue"], resolve);
const OrderChannelEdit = (resolve) =>
    require(["@/module/order/orderchannelEdit.vue"], resolve);
const GeneralAgentInventoryList = (resolve) =>
    require(["@/module/order/generalagentinventoryList.vue"], resolve);
const GeneralAgentInventoryView = (resolve) =>
    require(["@/module/order/generalagentinventoryView.vue"], resolve);

const OrderList = (resolve) =>
    require(["@/module/order/orderList.vue"], resolve);
const OrderEdit = (resolve) =>
    require(["@/module/order/orderEdit.vue"], resolve);
const ShipmentList = (resolve) =>
    require(["@/module/shipment/shipmentList.vue"], resolve);
const ShipmentView = (resolve) =>
    require(["@/module/shipment/shipmentView.vue"], resolve);
const InvoiceList = (resolve) =>
    require(["@/module/invoice/invoiceList.vue"], resolve);
const InvoiceView = (resolve) =>
    require(["@/module/invoice/invoiceView.vue"], resolve);
const BillingList = (resolve) =>
    require(["@/module/billing/billingList.vue"], resolve);
const BillingView = (resolve) =>
    require(["@/module/billing/billingView.vue"], resolve);
const ContractList = (resolve) =>
    require(["@/module/contract/ContractList.vue"], resolve);
const ContractView = (resolve) =>
    require(["@/module/contract/ContractView.vue"], resolve);

const SaleOrderList = (resolve) =>
    require(["@/module/order/saleorderList.vue"], resolve);
const SaleOrderView = (resolve) =>
    require(["@/module/order/saleorderView.vue"], resolve);

const ShoppingMallChooseProduct = (resolve) =>
    require(["@/module/quickorder/chooseProduct.vue"], resolve);
const ShoppingMallSearchProduct = (resolve) =>
    require(["@/module/quickorder/searchProduct.vue"], resolve);
const ProductDetail = (resolve) =>
    require(["@/module/quickorder/productDetail.vue"], resolve);
const OrderConfirm = (resolve) =>
    require(["@/module/quickorder/confirm.vue"], resolve);
const OrderComplete = (resolve) =>
    require(["@/module/quickorder/complete.vue"], resolve);
const ShoppingMallImportProduct = (resolve) =>
    require(["@/module/quickorder/importProduct.vue"], resolve);

const ForecastList = (resolve) =>
    require(["@/module/forecast/forecastList.vue"], resolve);
const ForecastView = (resolve) =>
    require(["@/module/forecast/forecastView.vue"], resolve);

const FileDownloadList = (resolve) =>
    require(["@/module/filedownload/filedownloadList.vue"], resolve);
const FileDownloadView = (resolve) =>
    require(["@/module/filedownload/filedownloadView.vue"], resolve);
const ForcecastReport = (resolve) =>
    require(["@/module/forecast/forcecastReport.vue"], resolve);

const SalesmanList = (resolve) =>
    require(["@/module/salesman/salesmanList.vue"], resolve);
const SalesmanView = (resolve) =>
    require(["@/module/salesman/salesmanView.vue"], resolve);
const SalesmanEdit = (resolve) =>
    require(["@/module/salesman/salesmanEdit.vue"], resolve);

const CreateOpportunity = (resolve) =>
    require(["@/module/opportunity/createOpportunity.vue"], resolve);
const CreateOpportunityDomestic = (resolve) =>
    require(["@/module/opportunity/CreateOpportunityDomestic.vue"], resolve);
const DetailEdit = (resolve) =>
    require(["@/module/opportunity/opportunitydetailEdit.vue"], resolve);
const DetailEditPortal = (resolve) =>
    require(["@/module/opportunity/opportunitydetailEditPortal.vue"], resolve);
const AddLeadDetailEdit = (resolve) =>
    require(["@/module/opportunity/AddLeadProduct.vue"], resolve);
const AddDetailEdit = (resolve) =>
    require(["@/module/opportunity/AddOpportunitydetailEdit.vue"], resolve);
const OpportunityList = (resolve) =>
    require(["@/module/opportunity/opportunityList.vue"], resolve);
const OpportunityEdit = (resolve) =>
    require(["@/module/opportunity/opportunityEdit.vue"], resolve);
//续保
const DetailContinueeditEditPortal = (resolve) =>
    require(["@/module/opportunity/continueedit_portal.vue"], resolve);

//add by devin.bai 测试机添加产品
const TestMachineDetailEdit = (resolve) =>
    require(["@/module/opportunity/testmachinedetailEdit.vue"], resolve);
const testmachinedetailTwoEdit = (resolve) =>
    require(["@/module/opportunity/testmachinedetailTwoEdit.vue"], resolve);
//续保申请 add wangke 230829 续保申请 begin
const ContinueEdit = (resolve) =>
    require(["@/module/continue/continueedit.vue"], resolve);
const Continueeimportdit = (resolve) =>
    require(["@/module/continue/continueeimportdit.vue"], resolve);
//续保申请 add wangke 230829 续保申请 begin

//渠道报备商机
const ChannelCreateOpportunity = (resolve) =>
    require(["@/module/channelOpportunity/createOpportunity.vue"], resolve);
//商机产品sn
const new_opportunitiesproductsn_List = (resolve) =>
    require(["@/module/new_opportunitiesproductsn/new_opportunitiesproductsnList.vue"], resolve);
const ChannelCreateOpportunityDomestic = (resolve) =>
    require(["@/module/channelOpportunity/CreateOpportunityDomestic.vue"], resolve);
const ChannelDetailEdit = (resolve) =>
    require(["@/module/channelOpportunity/opportunitydetailEdit.vue"], resolve)
const ChannelDetailEditPortal = (resolve) =>
    require(["@/module/channelOpportunity/opportunitydetailEditPortal.vue"], resolve)
const ChannelOpportunityList = (resolve) =>
    require(["@/module/channelOpportunity/opportunityList.vue"], resolve);
const ChannelOpportunityEdit = (resolve) =>
    require(["@/module/channelOpportunity/opportunityEdit.vue"], resolve);

//补件申请
const ResissueApplicationList = (resolve) =>
    require([
        "@/module/resissueapplication/resissueApplicationList.vue",
    ], resolve);
const ResissueApplicationDetail = (resolve) =>
    require([
        "@/module/resissueapplication/resissueApplicationDetail.vue",
    ], resolve);
const QuickOrderList = (resolve) =>
    require(["@/module/quickorder/quickOrderList.vue"], resolve);
const ProPriceList = (resolve) =>
    require(["@/module/proprice/propriceList.vue"], resolve);
const ProPriceView = (resolve) =>
    require(["@/module/proprice/propriceView.vue"], resolve);

//临时额度申请
const TempcreditList = (resolve) =>
    require(["@/module/tempcredit/tempcreditList.vue"], resolve);
const TempcreditView = (resolve) =>
    require(["@/module/tempcredit/tempcreditView.vue"], resolve);

//费用申请
const CostapplyList = (resolve) =>
    require(["@/module/costapply/costapplyList.vue"], resolve);
const CostapplyView = (resolve) =>
    require(["@/module/costapply/costapplyView.vue"], resolve);

//返利管理
const RebatedetailList = (resolve) =>
    require(["@/module/rebatedetail/rebatedetailList.vue"], resolve);

//财务管理   对账单
const AccountStatementList = (resolve) =>
    require(["@/module/accountstatement/accountstatementList.vue"], resolve);

const AccountStatementDetail = (resolve) =>
    require(["@/module/accountstatement/accountstatementDetail.vue"], resolve);
const ResetPasswordView = (resolve) =>
    require(["@/module/resetpassword/ResetPasswordView.vue"], resolve);
const ShoppingCartList = (resolve) =>
    require(["@/module/quickorder/shoppingCartList.vue"], resolve);

//报价单配置
const QuotationConfigList = (resolve) =>
    require(["@/module/quotationconfig/quotationConfigList.vue"], resolve);
const QuotationConfigDetail = (resolve) =>
    require(["@/module/quotationconfig/quotationConfigDetail.vue"], resolve);
const QuoteDetails = (resolve) =>
    require(["@/module/productCatalog/QuoteDetails.vue"], resolve);
const productCatalogIndex = (resolve) =>
    require(["@/module/productCatalog/productCatalogIndex.vue"], resolve);
const collectList = (resolve) =>
    require(["@/module/productCatalog/collectList.vue"], resolve);
const vehicleVarConfigList = (resolve) =>
    require(["@/module/productCatalog/vehicleVarConfigList.vue"], resolve);
const contractConfigList = (resolve) =>
    require(["@/module/productCatalog/ApplicationConfig.vue"], resolve);

// 渠道报备
const TestmachinechannelList = (resolve) =>
    require(["@/module/order/testmachinechannelList.vue"], resolve);
const TestmachinechannelView = (resolve) =>
    require(["@/module/order/testmachinechannelView.vue"], resolve);

const ChannelAccountList = (resolve) =>
    require(["@/module/channel/channelaccountList.vue"], resolve);
const Createchannelaccount = (resolve) =>
    require(["@/module/channel/createchannelaccount.vue"], resolve);
const ChannelContactsList = (resolve) =>
    require(["@/module/channel/channelcontactsList.vue"], resolve);
const CreateChannelContacts = (resolve) =>
    require(["@/module/channel/createchannelcontacts.vue"], resolve);
//客户
const AccountList = (resolve) =>
    require(["@/module/channel/accountList.vue"], resolve);
const AccountView = (resolve) =>
    require(["@/module/channel/accountView.vue"], resolve);

// 价格手册
const priceBookList = (resolve) =>
    require(["@/module/price/priceBookList.vue"], resolve);
const priceBookDetail = (resolve) =>
    require(["@/module/price/priceBookDetail.vue"], resolve);
// 报价单
const quotationList = (resolve) =>
    require(["@/module/quotation/quotationList.vue"], resolve);
//山石报价
const CreateQuotation = (resolve) =>
    require(["@/module/quotation/quotationEdit.vue"], resolve);
//山石报价产品明细
// const quotationdetailEditPortal = (resolve) =>
// require(["@/module/quotation/quotationdetailEditPortal.vue"], resolve);
const quotationdetailEdit = (resolve) =>
    require(["@/module/quotation/quotationdetailEdit.vue"], resolve);

//渠道报价
const channelQuotationEdit = (resolve) =>
    require(["@/module/quotation/channelQuotationEdit.vue"], resolve);
const quotedetailEdit = (resolve) =>
    require(["@/module/quotation/quotedetailEdit.vue"], resolve);
//价格修改
const quotationdetailPriceEdit = (resolve) =>
    require(["@/module/quotation/quotationdetailPriceEdit.vue"], resolve);
//代理商业绩快照
const AgentSnapShotList = (resolve) =>
    require(["@/module/new_agentsnapshot/new_agentsnapshotList.vue"], resolve);
const AgentSnapShotReport = (resolve) =>
    require(["@/module/new_agentsnapshot/new_agentsnapshotReport.vue"], resolve);
const DistributorPerformancesnapShotReport = (resolve) =>
    require(["@/module/new_agentsnapshot/new_distributorperformancesnapshot.vue"], resolve);

// 测试机申请

const BorrowfacilityView = (resolve) =>
    require(["@/module/testmachine/BorrowfacilityView.vue"], resolve);
const testmachineList = (resolve) =>
    require(["@/module/testmachine/testmachineList.vue"], resolve);
const Createtestmachine = (resolve) =>
    require(["@/module/testmachine/testmachineEdit.vue"], resolve);
// 二维码
const CampaignApply = (resolve) =>
    require(["@/module/qrcode/CampaignApply.vue"], resolve);
const CampaignSignin = (resolve) =>
    require(["@/module/qrcode/CampaignSignin.vue"], resolve);
const CampaignFeedback = (resolve) =>
    require(["@/module/qrcode/CampaignFeedback.vue"], resolve);

const SubmitOk = (resolve) =>
    require(["@/module/qrcode/SubmitOk.vue"], resolve);

// 产品对比
const ComparisonList = (resolve) =>
    require(["@/module/compare/comparisonList.vue"], resolve);
const ComparisonView = (resolve) =>
    require(["@/module/compare/comparisonView.vue"], resolve);

// Test  new_order_inventory
// const new_order_inventoryList = (resolve) =>
// require(["@/module/new_order_inventory/new_order_inventoryList.vue"], resolve);
// const new_order_inventoryEdit = (resolve) =>
// require(["@/module/new_order_inventory/new_order_inventoryEdit.vue"], resolve);


//开票申请单
const new_ord_invoiceList = (resolve) =>
    require(["@/module/new_ord_invoice/new_ord_invoiceList.vue"], resolve);
const new_ord_invoiceEdit = (resolve) =>
    require(["@/module/new_ord_invoice/new_ord_invoiceEdit.vue"], resolve);
//开票申请单明细
const new_ord_invoicelineEdit = (resolve) =>
    require(["@/module/new_ord_invoice/new_ord_invoicelineEdit.vue"], resolve);

//回款认领单
const new_ord_billingList = (resolve) =>
    require(["@/module/new_ord_billing/new_ord_billingList.vue"], resolve);
const new_ord_billingEdit = (resolve) =>
    require(["@/module/new_ord_billing/new_ord_billingEdit.vue"], resolve);
//回款认领明细
const new_ord_billinglineEdit = (resolve) =>
    require(["@/module/new_ord_billing/new_ord_billinglineEdit.vue"], resolve);

//渠道回款认领单
const new_channel_billingList = (resolve) =>
    require(["@/module/new_channel_billing/new_channel_billingList.vue"], resolve);
const new_channel_billingEdit = (resolve) =>
    require(["@/module/new_channel_billing/new_channel_billingEdit.vue"], resolve);
//渠道回款认领明细
const new_channel_billinglineEdit = (resolve) =>
    require(["@/module/new_channel_billing/new_channel_billinglineEdit.vue"], resolve);

//返利池
const new_profitpoolList = (resolve) =>
    require(["@/module/new_profitpool/new_profitpoolList.vue"], resolve);
const new_profitpoolEdit = (resolve) =>
    require(["@/module/new_profitpool/new_profitpoolEdit.vue"], resolve);
//返利池明细
const new_rebateEdit = (resolve) =>
    require(["@/module/new_profitpool/new_rebateEdit.vue"], resolve);
const new_rebateEditlineEdit = (resolve) =>
    require(["@/module/new_profitpool/new_rebateEditlineEdit.vue"], resolve);

// LIC申请单
const new_lic_applicationList = (resolve) =>
    require([
        "@/module/new_lic_application/new_lic_applicationList.vue",
    ], resolve);
const new_lic_applicationEdit = (resolve) =>
    require([
        "@/module/new_lic_application/new_lic_applicationEdit.vue",
    ], resolve);
const new_lic_applicationlineEdit = (resolve) =>
    require([
        "@/module/new_lic_application/new_lic_applicationlineEdit.vue",
    ], resolve);
const new_lic_application_snEdit = (resolve) =>
    require([
        "@/module/new_lic_application/new_lic_application_snEdit.vue",
    ], resolve);
//Lic申请单
const new_lic_application_add_SN = (resolve) =>
    require([
        "@/module/new_lic_application/new_lic_application_add_SN.vue",
    ], resolve);
//续保Lic申请单添加SN
const new_lic_application_add_SNContinue = (resolve) =>
    require([
        "@/module/new_lic_application/new_lic_application_add_SNContinue.vue",
    ], resolve);

//产品查询
const productSearchDetail = (resolve) =>
    require(["@/module/product/productSearchDetail.vue"], resolve);

// 代理商续约
const new_agent_renewalList = (resolve) =>
    require(["@/module/new_agent_renewal/new_agent_renewalList.vue"], resolve);
const new_agent_renewalEdit = (resolve) =>
    require(["@/module/new_agent_renewal/new_agent_renewalEdit.vue"], resolve);
// 用户画像
const new_userprofileList = (resolve) =>
    require(["@/module/new_userprofile/new_userprofileList.vue"], resolve);
const new_userprofileEdit = (resolve) =>
    require(["@/module/new_userprofile/new_userprofileEdit.vue"], resolve);
const new_decisionmakerEdit = (resolve) =>
    require(["@/module/new_userprofile/new_decisionmakerEdit.vue"], resolve);
const new_industrycoverageEdit = (resolve) =>
    require(["@/module/new_userprofile/new_industrycoverageEdit.vue"], resolve);
const new_internalliaisonpersonEdit = (resolve) =>
    require(["@/module/new_userprofile/new_internalliaisonpersonEdit.vue"], resolve);
const new_organizationalkeypersonnelEdit = (resolve) =>
    require(["@/module/new_userprofile/new_organizationalkeypersonnel.vue"], resolve);
const new_partnerproductinfoEdit = (resolve) =>
    require(["@/module/new_userprofile/new_partnerproductinfoEdit.vue"], resolve);
const new_importantprojectpriceEdit = (resolve) =>
    require(["@/module/new_userprofile/new_importantprojectpriceEdit.vue"], resolve);
//银行流水
const new_bankinfoList = (resolve) =>
    require(["@/module/new_bankinfo/new_bankinfoList.vue"], resolve);
const new_bankinfoEdit = (resolve) =>
    require(["@/module/new_bankinfo/new_bankinfoEdit.vue"], resolve);

//渠道开票
const new_channel_invoiceList = (resolve) =>
    require([
        "@/module/new_channel_invoice/new_channel_invoiceList.vue",
    ], resolve);
const new_channel_invoiceEdit = (resolve) =>
    require([
        "@/module/new_channel_invoice/new_channel_invoiceEdit.vue",
    ], resolve);
//新建渠道开票明细
const new_channel_invoicelineEdit = (resolve) =>
    require([
        "@/module/new_channel_invoice/new_channel_invoicelineEdit.vue",
    ], resolve);

//产品查询
// const new_product_queryList = (resolve) =>
// require(["@/module/new_product_query/new_product_queryList.vue"], resolve);
//审批页
const ApproveList = (resolve) =>
    require(["@/module/vflow/ApproveList.vue"], resolve);

// 山石订单
const new_order_change_applicationDetail = (resolve) =>
    require(["@/module/new_order_change_application/new_order_change_applicationDetail.vue"], resolve);
const new_order_change_applicationList = (resolve) =>
    require(["@/module/new_order_change_application/new_order_change_applicationList.vue"], resolve);

const new_ord_saleorderList = (resolve) =>
    require(["@/module/new_ord_saleorder/new_ord_saleorderList.vue"], resolve);

const new_ord_saleorderEdit = (resolve) =>
    require(["@/module/new_ord_saleorder/new_ord_saleorderEdit.vue"], resolve);
//产品
const new_ord_saleorderdetailEdit = (resolve) =>
    require(["@/module/new_ord_saleorder/new_ord_saleorderdetailEdit.vue"], resolve);
//posku
const new_ord_saleorderlineEdit = (resolve) =>
    require(["@/module/new_ord_saleorder/new_ord_saleorderlineEdit.vue"], resolve);
//物流
const new_expressEdit = (resolve) =>
    require(["@/module/new_ord_saleorder/new_expressEdit.vue"], resolve);
//sn
const new_ord_snEdit = (resolve) =>
    require(["@/module/new_ord_saleorder/new_ord_snEdit.vue"], resolve);
//随机续保挂SN
const OnRenewalAddSN = (resolve) =>
    require(["@/module/new_ord_saleorder/OnRenewalAddSN.vue"], resolve);


//渠道订单
const new_channel_saleorderList = (resolve) =>
    require(["@/module/new_channel_saleorder/new_channel_saleorderList.vue"], resolve);
const new_channel_saleorderEdit = (resolve) =>
    require(["@/module/new_channel_saleorder/new_channel_saleorderEdit.vue"], resolve);
//产品
const new_channel_saleorderdetailEdit = (resolve) =>
    require(["@/module/new_channel_saleorder/new_ord_saleorderdetailEdit.vue"], resolve);
//posku
const new_channel_saleorderlineEdit = (resolve) =>
    require(["@/module/new_channel_saleorder/new_ord_saleorderlineEdit.vue"], resolve);
//物流
const new_channel_saleordernew_expressEdit = (resolve) =>
    require(["@/module/new_channel_saleorder/new_expressEdit.vue"], resolve);
//sn
const new_channel_saleordernew_ord_snEdit = (resolve) =>
    require(["@/module/new_channel_saleorder/new_ord_snEdit.vue"], resolve);
//退货
const new_channel_cancelsendgood = (resolve) =>
    require(["@/module/new_channel_saleorder/new_channel_cancelsendgood.vue"], resolve);
//安全集成订单发货(指定批次/SN)   转发货
const new_channel_transfromshipment = (resolve) =>
    require(["@/module/new_channel_saleorder/new_channel_transfromshipment.vue"], resolve);
//订单挂SN
const new_channel_hangSN = (resolve) =>
    require(["@/module/new_channel_saleorder/new_channel_hangSN.vue"], resolve);

//总渠道库存
const new_channelinventoryList = (resolve) =>
    require(["@/module/new_channelinventory/new_channelinventoryList.vue"], resolve);
const new_channelinventoryEdit = (resolve) =>
    require(["@/module/new_channelinventory/new_channelinventoryEdit.vue"], resolve);
const new_softwareinventoryEdit = (resolve) =>
    require(["@/module/new_channelinventory/new_softwareinventoryEdit.vue"], resolve);

// 订单渠道库存
const new_order_inventoryList = (resolve) =>
    require(["@/module/new_order_inventory/new_order_inventoryList.vue"], resolve);
const new_order_inventoryEdit = (resolve) =>
    require(["@/module/new_order_inventory/new_order_inventoryEdit.vue"], resolve);
const new_order_inventory_listEdit = (resolve) =>
    require(["@/module/new_order_inventory/new_order_inventory_listEdit.vue"], resolve);
const new_order_product_inventory_listEdit = (resolve) =>
    require(["@/module/new_order_inventory/new_order_product_inventory_listEdit.vue"], resolve);
const new_snrecordEdit = (resolve) =>
    require(["@/module/new_order_inventory/new_snrecordEdit.vue"], resolve);
//测试
// const accountList = (resolve) =>
// require(["@/module/Test/accountList.vue"], resolve);
// const accountEdit = (resolve) =>
// require(["@/module/Test/accountEdit.vue"], resolve);

//发货单
const new_ord_shipmentList = (resolve) =>
    require(["@/module/new_ord_shipment/new_ord_shipmentList.vue"], resolve);
const new_ord_shipmentEdit = (resolve) =>
    require(["@/module/new_ord_shipment/new_ord_shipmentEdit.vue"], resolve);

//发货明细
const new_ord_shipmentlineList = (resolve) =>
    require(["@/module/new_ord_shipmentline/new_ord_shipmentlineList.vue"], resolve);
const new_ord_shipmentlineEdit = (resolve) =>
    require(["@/module/new_ord_shipmentline/new_ord_shipmentlineEdit.vue"], resolve);

//渠道发货
const new_channel_shipmentEdit = (resolve) =>
    require(["@/module/new_ord_shipment/new_channel_shipmentEdit.vue"], resolve);

//渠道发货明细
const new_channel_shipmentlineEdit = (resolve) =>
    require(["@/module/new_ord_shipment/new_channel_shipmentlineEdit.vue"], resolve);

//业绩查询

const achievementList = (resolve) =>
    require(["@/module/achievement/achievementList.vue"], resolve);
//季度
const quarterAchievementList = (resolve) =>
    require(["@/module/achievement/quarterAchievementList.vue"], resolve);
//业绩detail
const achievementDetailList = (resolve) =>
    require(["@/module/achievement/achievementDetailList.vue"], resolve);

//知识库
const knowledgeCreate = (resolve) =>
    require(["@/module/knowledge/knowledgeCreate.vue"], resolve);
const knowledgeDetail = (resolve) =>
    require(["@/module/knowledge/knowledgeDetail.vue"], resolve);
const knowledgeEdit = (resolve) =>
    require(["@/module/knowledge/knowledgeEdit.vue"], resolve);
const knowledgeList = (resolve) =>
    require(["@/module/knowledge/knowledgeList.vue"], resolve);
const knowledgeContentDetail = (resolve) =>
    require(["@/module/knowledge/knowledgeContentDetail.vue"], resolve);


//培训
const new_certificatie_traindetailList = (resolve) =>
    require(["@/module/new_certificatie_traindetail/new_certificatie_traindetailList.vue"], resolve);
const new_certificatie_traindetailEdit = (resolve) =>
    require(["@/module/new_certificatie_traindetail/new_certificatie_traindetailEdit.vue"], resolve);
//经销商人员档案
const new_accountstaffList = (resolve) =>
    require(["@/module/new_accountstaff/new_accountstaffList.vue"], resolve);
const new_accountstaffEdit = (resolve) =>
    require(["@/module/new_accountstaff/new_accountstaffEdit.vue"], resolve);
//代理商信息表
const new_agentimformationList = (resolve) =>
    require(["@/module/new_agentimformation/new_agentimformationList.vue"], resolve);
const new_agentimformationEdit = (resolve) =>
    require(["@/module/new_agentimformation/new_agentimformationEdit.vue"], resolve);

//山石订单产品sn
const new_ord_snList = (resolve) =>
    require(["@/module/new_ord_sn/new_ord_snList.vue"], resolve);
//渠道订单产品
const new_channel_saleorderdetailList = (resolve) =>
    require(["@/module/new_channel_saleorderdetail/new_channel_saleorderdetailList.vue"], resolve);
//订单渠道库存明细
const new_order_inventory_listList = (resolve) =>
    require(["@/module/new_order_inventory_list/new_order_inventorylistList.vue"], resolve);
//lic sn
const new_lic_application_snList = (resolve) =>
    require(["@/module/new_lic_application_sn/new_lic_application_snList.vue"], resolve);

// 信用额度
const credituselineList = (resolve) =>
    require(["@/module/credituseline/credituselineList.vue"], resolve);

//市场竞分管理
const campaignCompeteList = (resolve) =>
    require(["@/module/campaignCompete/campaignCompeteList.vue"], resolve);
const campaignCompeteEdit = (resolve) =>
    require(["@/module/campaignCompete/campaignCompeteEdit.vue"], resolve);

//产品库存
const new_productstockList = (resolve) =>
    require(["@/module/new_productstock/new_productstockList.vue"], resolve);
const new_productstockEdit = (resolve) =>
    require(["@/module/new_productstock/new_productstockEdit.vue"], resolve);

const new_ai = (resolve) =>
    require(["@/module/new_ai/new_ai.vue"], resolve);
const new_selection = (resolve) =>
    require(["@/module/new_ai/new_selection.vue"], resolve);
const new_opportunityaccountai = (resolve) =>
    require(["@/module/new_ai/new_opportunityaccountai.vue"], resolve);
const MallRedirect = (resolve) =>
    require(["@/module/mall/redirect.vue"], resolve);
const MallIframe = (resolve) =>
    require(["@/module/mall/iframe.vue"], resolve);
const new_middleground = (resolve) =>
    require(["@/module/new_ai/new_middleground.vue"], resolve);
const new_lingyan = (resolve) =>
    require(["@/module/new_ai/new_lingyan.vue"], resolve);
const new_presales = (resolve) =>
    require(["@/module/new_ai/new_presales.vue"], resolve);
export default [
    //市场竞分管理
    {
        path: "/campaignCompete",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "campaignCompete-list",
                component: campaignCompeteList,
            },
            {
                path: "edit/:id?",
                name: "campaignCompete-edit",
                component: campaignCompeteEdit,
            },
        ],
    },

    //山石订单产品sn
    {
        path: "/new_ord_sn",
        component: getViews("Main"),
        children: [{
            path: "list",
            name: "new_ord_sn-list",
            component: new_ord_snList,
        }, ],
    },
    //渠道订单产品
    {
        path: "/new_channel_saleorderdetail",
        component: getViews("Main"),
        children: [{
            path: "list",
            name: "new_channel_saleorderdetail-list",
            component: new_channel_saleorderdetailList,
        }, ],
    },
    //订单渠道库存明细
    {
        path: "/new_order_inventorylist",
        component: getViews("Main"),
        children: [{
            path: "list",
            name: "new_order_inventory_list-list",
            component: new_order_inventory_listList,
        }, ],
    },
    //商机产品sn
    {
        path: "/new_opportunitiesproductsn",
        component: getViews("Main"),
        children: [{
            path: "list",
            name: "new_opportunitiesproductsn-list",
            component: new_opportunitiesproductsn_List,
        }, ],
    },
    //licsn
    {
        path: "/new_lic_application_sn",
        component: getViews("Main"),
        children: [{
            path: "list",
            name: "new_lic_application_sn-list",
            component: new_lic_application_snList,
        }, ],
    },
    //经销商人员档案
    {
        path: "/new_accountstaff",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "new_accountstaff-list",
                component: new_accountstaffList,
            },
            {
                path: "edit/:id?",
                name: "new_accountstaff-edit",
                component: new_accountstaffEdit,
            },
        ],
    },
    //代理商信息表
    {
        path: "/new_agentimformation",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "new_agentimformation-list",
                component: new_agentimformationList,
            },
            {
                path: "edit/:id?",
                name: "new_agentimformation-edit",
                component: new_agentimformationEdit,
            },
        ],
    }, {
        path: "/knowledgeCrm",
        component: CRM,
        children: [
            //山石/渠道   知识库
            {
                path: "list",
                name: "crm__knowledgeList",
                component: knowledgeList,
            },
            {
                path: "detail/:id?/:type?/:documentid?",
                name: "crm__knowledge-detail",
                component: knowledgeDetail,
            },
            {
                path: "edit/:documentid?/:id?",
                name: "crm__knowledge-edit",
                component: knowledgeEdit,
            },
        ],
    },
    {
        path: "/knowledge",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "knowledge-list",
                component: knowledgeList,
            },
            {
                path: "edit/:documentid?/:id?",
                name: "knowledge-edit",
                component: knowledgeEdit,
            },
            {
                path: "detail/:id?/:type?/:documentid?",
                name: "knowledge-detail",
                component: knowledgeDetail,
            },
            {
                path: "create",
                name: "knowledge-create",
                component: knowledgeCreate,
            },
            {
                path: "knowledgecontent",
                name: "knowledgecontent-detail",
                component: knowledgeContentDetail,
            },
        ],
    },
    // {
    //   path: "/testaccount",
    //   component: getViews("Main"),
    //   children: [
    //     {
    //       path: "list",
    //       name: "account-list",
    //       component: accountList,
    //     },
    //     {
    //       path: "edit/:id",
    //       name: "account-edit",
    //       component: accountEdit,
    //     },
    //   ],
    // },
    //培训
    {
        path: "/new_certificatie_traindetail",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "new_certificatie_traindetail-list",
                component: new_certificatie_traindetailList,
            },
            {
                path: "edit/:id?",
                name: "new_certificatie_traindetail-edit",
                component: new_certificatie_traindetailEdit,
            },
        ],
    },

    //业绩查询（年度）
    {
        path: "/achievement",
        component: getViews("Main"),
        children: [{
            path: "list",
            name: "achievement-list",
            component: achievementList,
        }, ],
    },
    //业绩查询（季度）
    {
        path: "/quarter",
        component: getViews("Main"),
        children: [{
            path: "list",
            name: "quarter-list",
            component: quarterAchievementList,
        }, ],
    },
    //业绩detail
    {
        path: "/achievementDetail",
        component: getViews("Main"),
        children: [{
            path: "list",
            name: "achievementDetail-list",
            component: achievementDetailList,
        }, ],
    },

    //订单渠道库存
    {
        path: "/new_order_inventory",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "new_order_inventory-list",
                component: new_order_inventoryList,
            },
            {
                path: "edit/:id",
                name: "new_order_inventory-edit",
                component: new_order_inventoryEdit,
            },
            {
                path: "new_order_inventory_listedit/:id",
                name: "new_order_inventory_list-edit",
                component: new_order_inventory_listEdit,
            },
            {
                path: "new_order_product_inventory_listedit/:id",
                name: "new_order_product_inventory_list-edit",
                component: new_order_product_inventory_listEdit,
            },
            {
                path: "new_snrecord/:id",
                name: "new_snrecord-edit",
                component: new_snrecordEdit,
            },

        ],
    },
    //总渠道库存 
    {
        path: "/new_channelinventory",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "new_channelinventory-list",
                component: new_channelinventoryList,
            },
            {
                path: "edit/:id?",
                name: "new_channelinventory-edit",
                component: new_channelinventoryEdit,
            },
            {
                path: "new_softwareinventoryedit/:id?",
                name: "new_softwareinventory-edit",
                component: new_softwareinventoryEdit,
            },


        ],
    },
    //产品库存 
    {
        path: "/new_productstock",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "new_productstock-list",
                component: new_productstockList,
            },
            {
                path: "edit/:id?",
                name: "new_productstock-edit",
                component: new_productstockEdit,
            },

        ],
    },
    //AI
    {
        path: "/new_ai",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "new_ai-list",
                component: new_ai,
            }, {
                path: "selectionlist",
                name: "selectionlist-list",
                component: new_selection,
            }, {
                path: "opportunityaccountaiselect",
                name: "opportunityaccountaiselect-list",
                component: new_opportunityaccountai,
            }, {
                path: "middleground",
                name: "middleground-list",
                component: new_middleground,
            }, {
                path: "lingyan",
                name: "lingyan-list",
                component: new_lingyan,
            }, {
                path: "presales",
                name: "presales-list",
                component: new_presales,
            }

        ],
    },
    //商城跳转
    {
        path: "/mall",
        component: getViews("Main"),
        children: [{
            path: "redirect",
            name: "mall-redirect",
            component: MallRedirect,
        }, {
            path: "iframe",
            name: "mall-iframe",
            component: MallIframe,
        }],
    },
    {
        path: "/",
        component: Home,
        children: [{
            path: "/",
            name: "home",
            meta: {
                keepAlive: true,
                allowAnonymous: true,
            },
            component: Home,
        }, ],
    },
    {
        path: "/home1",
        component: getViews("Main"),
        children: [{
            path: "/home1",
            name: "home1",
            component: Home1,
        }, ],
    },
    {
        path: "/edit",
        component: getViews("Main"),
        children: [{
            path: "apply",
            name: "editApply",
            component: EditApply,
        }, ],
    },
    {
        path: "/message",
        component: getViews("Main"),
        children: [{
            path: "message",
            name: "message",
            meta: {
                keepAlive: true,
            },
            component: Message,
        }, ],
    },
    {
        path: "/menu",
        component: getProductViews("productMain"),
        children: [{
            path: "menulist",
            name: "menu-list",
            meta: {
                allowAnonymous: true,
            },
            component: MenuList,
        }, ],
    },
    {
        path: "/new_agent_renewal",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "new_agent_renewal-list",
                component: new_agent_renewalList,
            },
            {
                path: "edit/:id?",
                name: "new_agent_renewal-edit",
                component: new_agent_renewalEdit,
            },
        ],
    },
    {
        path: "/new_userprofile",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "new_userprofile-list",
                component: new_userprofileList,
            },
            {
                path: "edit/:id?",
                name: "new_userprofile-edit",
                component: new_userprofileEdit,
            },
            {
                path: "addmaker/:profileId/:makerId?",
                name: "new_decisionmaker-edit",
                component: new_decisionmakerEdit,
            },
            {
                path: "addindustry/:profileId/:industryId?",
                name: "new_industrycoverage-edit",
                component: new_industrycoverageEdit,
            },
            {
                path: "addperson/:profileId/:personId?",
                name: "new_internalliaisonperson-edit",
                component: new_internalliaisonpersonEdit,
            },
            {
                path: "addkeyperson/:profileId/:keypersonId?",
                name: "new_organizationalkeypersonnel-edit",
                component: new_organizationalkeypersonnelEdit,
            },
            {
                path: "addproduct/:profileId/:productId?",
                name: "new_partnerproductinfo-edit",
                component: new_partnerproductinfoEdit,
            },
            {
                path: "addproject/:profileId/:personId?",
                name: "new_importantprojectprice-edit",
                component: new_importantprojectpriceEdit,
            },
        ],
    },
    {
        path: "/new_order_change_application",
        component: getViews("Main"),
        children: [
            {
                path: "list",
                name: "new_order_change_application-list",
                component: new_order_change_applicationList,
            },
            {
                path: "detail/:id?",
                name: "new_order_change_application-Detail",
                component: new_order_change_applicationDetail,
            },
        ],
    },
    //山石订单
    {
        path: "/new_ord_saleorder",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "new_ord_saleorder-list",
                component: new_ord_saleorderList,
            },
            {
                path: "edit/:id?",
                name: "new_ord_saleorder-edit",
                component: new_ord_saleorderEdit,
            },
            //产品
            {
                path: "new_ord_saleorderdetailedit/:id?",
                name: "new_ord_saleorderdetail-edit",
                component: new_ord_saleorderdetailEdit,
            },
            //posku
            {
                path: "new_ord_saleorderlineedit/:id?",
                name: "new_ord_saleorderline-edit",
                component: new_ord_saleorderlineEdit,
            },
            //物流
            {
                path: "new_expressedit/:id?",
                name: "new_express-edit",
                component: new_expressEdit,
            },
            //sn
            {
                path: "new_ord_snedit/:id?",
                name: "new_ord_sn-edit",
                component: new_ord_snEdit,
            },
            //随机续保挂SN
            {
                path: "OnRenewalAddSN/:id?",
                name: "OnRenewalAddSN",
                component: OnRenewalAddSN,
            },

        ],
    },
    {
        path: "/approveList",
        component: getViews("Main"),
        children: [{
            path: "list",
            name: "approvelist-list",
            component: ApproveList,
        }],
    },
  
    //渠道订单
    {
        path: "/new_channel_saleorder",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "new_channel_saleorder-list",
                component: new_channel_saleorderList,
            },
            {
                path: "edit/:id?",
                name: "new_channel_saleorder-edit",
                component: new_channel_saleorderEdit,
            },
            {
                path: "cancelsendgood/:id?",
                name: "new_channel_cancelsendgood-edit",
                component: new_channel_cancelsendgood,
            },
            //sn转发货
            {
                path: "new_channel_transfromshipmentedit/:id?",
                name: "new_channel_transfromshipment-edit",
                component: new_channel_transfromshipment,
            },
            //挂SN
            {
                path: "hangSN/:id?",
                name: "new_channel_hangSN-edit",
                component: new_channel_hangSN,
            },
            //产品
            {
                path: "new_channel_saleorderdetailedit/:id?",
                name: "new_channel_saleorderdetail-edit",
                component: new_channel_saleorderdetailEdit,
            },
            //posku
            {
                path: "new_channel_saleorderlineedit/:id?",
                name: "new_channel_saleorderline-edit",
                component: new_channel_saleorderlineEdit,
            },
            //物流
            {
                path: "new_channel_saleordernew_expressedit/:id?",
                name: "new_channel_saleordernew_express-edit",
                component: new_channel_saleordernew_expressEdit,
            },
            //sn
            {
                path: "new_channel_saleorderedit/:id?",
                name: "new_channel_saleorder-edit",
                component: new_channel_saleordernew_ord_snEdit,
            },



        ],
    },
    {
        path: "/new_lic_application",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "new_lic_application-list",
                component: new_lic_applicationList,
            },
            {
                path: "edit/:id?",
                name: "new_lic_application-edit",
                component: new_lic_applicationEdit,
            },
            {
                path: "detailedit/:id?",
                name: "new_lic_applicationline-edit",
                component: new_lic_applicationlineEdit,
            },
            {
                path: "detailsnedit/:id?",
                name: "new_lic_application_sn-edit",
                component: new_lic_application_snEdit,
            },
            {
                path: "addSN/:id?",
                name: "lic_add_sn",
                component: new_lic_application_add_SN,
            },
            {
                path: "addcontinueSN/:id?",
                name: "lic_addcontinue_sn",
                component: new_lic_application_add_SNContinue,
            }
        ],
    },
    {
        path: "/new_ord_invoice",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "new_ord_invoice-list",
                meta: {
                    // keepAlive: true,
                    allowAnonymous: true,
                },
                component: new_ord_invoiceList,
            },
            {
                path: "edit/:id",
                name: "new_ord_invoice-edit",
                component: new_ord_invoiceEdit,
            },
            {
                path: "detailedit/:id",
                name: "new_ord_invoicelineEdit-edit",
                component: new_ord_invoicelineEdit,
            },
        ],
    },
    //回款认领
    {
        path: "/new_ord_billing",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "new_ord_billing-list",
                meta: {
                    // keepAlive:true
                },
                component: new_ord_billingList,
            },
            {
                path: "edit/:id?/:bankid?",
                name: "new_ord_billing-edit",
                component: new_ord_billingEdit,
            },
            {
                path: "detailedit/:id?/:billingid?",
                name: "new_ord_billingline-edit",
                component: new_ord_billinglineEdit,
            },
        ],
    },
    //渠道回款认领
    {
        path: "/new_channel_billing",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "new_channel_billing-list",
                component: new_channel_billingList,
            },
            {
                path: "edit/:id?",
                name: "new_channel_billing-edit",
                component: new_channel_billingEdit,
            },
            {
                path: "detailedit/:id?/:billingid?/:status?",
                name: "new_channel_billingline-edit",
                component: new_channel_billinglineEdit,
            },


        ],
    },
    {
        path: "/new_profitpool",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "new_profitpool-list",
                component: new_profitpoolList,
            },
            {
                path: "edit/:id",
                name: "new_profitpool-edit",
                component: new_profitpoolEdit,
            },
            {
                path: "detailedit/:id",
                name: "new_profitpoolline-edit",
                component: new_rebateEdit,
            },
            {
                path: "detaillineedit/:id",
                name: "new_rebateEditline-edit",
                component: new_rebateEditlineEdit,
            },
        ],
    },
    // {
    //     path: "/new_order_inventory",
    //     component: getViews("Main"),
    //     children: [
    //       {
    //         path: "list",
    //         name: "new_order_inventory-list",
    //         component: new_order_inventoryList,
    //       },
    //       {
    //         path: "edit/:id",
    //         name: "new_order_inventory-edit",
    //         component: new_order_inventoryEdit,
    //       },
    //     ],
    //   },

    {
        path: "/new_product_query",
        component: getViews("Main"),
        children: [{
            path: "list",
            name: "productSearchDetail",
            component: productSearchDetail,
        }],
    },
    {
        path: "/notice",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "NoticeList",
                component: NoticeList,
            },
            {
                path: "view/:id?",
                name: "notice-detail",
                component: NoticeView,
            },
        ],
    },
    {
        path: "/shoppingmall",
        component: getProductViews("productMain"),
        children: [{
                path: "chooseproduct/:name?/:id?",
                name: "ShoppingMallChooseProduct",
                meta: {
                    allowAnonymous: true,
                },
                component: ShoppingMallChooseProduct,
            },
            {
                path: "searchproduct/:name?",
                name: "ShoppingMallSearchProduct",
                meta: {
                    allowAnonymous: true,
                },
                component: ShoppingMallSearchProduct,
            },
            {
                path: "productdetail",
                name: "product-detail",
                meta: {
                    allowAnonymous: true,
                },
                component: ProductDetail,
            },
        ],
    },
    {
        path: "/collect",
        component: getViews("Main"),
        children: [{
            path: "view",
            name: "collect-view",
            component: CollectView,
        }, ],
    },

    {
        path: "/shipment",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "ShipmentList",
                component: ShipmentList,
            },
            {
                path: "view/:id",
                name: "ShipmentView",
                component: ShipmentView,
            },
        ],
    },
    {
        path: "/invoice",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "InvoiceList",
                component: InvoiceList,
            },
            {
                path: "view/:id",
                name: "InvoiceView",
                component: InvoiceView,
            },
        ],
    },
    {
        path: "/billing",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "BillingList",
                component: BillingList,
            },
            {
                path: "view/:id",
                name: "BillingView",
                component: BillingView,
            },
        ],
    },

    {
        path: "/trainingnotice",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "TrainingnoticeList",
                component: TrainingnoticeList,
            },
            {
                path: "trainingnoticeview/:id",
                name: "TrainingnoticeView",
                component: TrainingnoticeView,
            },
        ],
    },

    {
        path: "/order",
        component: getViews("Main"),
        children: [{
                path: "orderlist",
                name: "OrderList",
                component: OrderList,
            },
            {
                path: "orderedit",
                name: "OrderEdit",
                component: OrderEdit,
            },
            {
                path: "testmachinechannellist",
                name: "TestmachinechannelList",
                component: TestmachinechannelList,
            },

            {
                path: "testmachinechannelView/:id",
                name: "TestmachinechannelView",
                component: TestmachinechannelView,
            },

            {
                path: "orderchannel",
                name: "OrderChannel",
                component: OrderChannel,
            },

            {
                path: "orderchannelEdit/:id",
                name: "OrderChannelEdit",
                component: OrderChannelEdit,
            },
            {
                path: "GeneralAgentInventoryList",
                name: "GeneralAgentInventoryList",
                component: GeneralAgentInventoryList,
            },
            {
                path: "GeneralAgentInventoryView/:id",
                name: "GeneralAgentInventoryView",
                component: GeneralAgentInventoryView,
            },
            {
                path: "list",
                name: "SaleOrderList",
                component: SaleOrderList,
            },
            {
                path: ":id/:name/:time/complete",
                name: "OrderComplete",
                component: OrderComplete,
            },
            {
                path: ":id/detail",
                name: "order-detail",
                component: SaleOrderView,
            },
        ],
    },
    {
        path: "/channel",
        alias: "/account",
        component: getViews("Main"),
        children: [{
                path: "accountList",
                name: "AccountList",
                component: AccountList,
            },
            {
                path: "accountView/:id",
                name: "AccountView",
                alias: "edit/:id", //起别名  用于lookup跳转
                component: AccountView,
            },

            {
                path: "list",
                name: "ChannelAccountList",
                component: ChannelAccountList,
            },
            {
                path: "create/:id?",
                name: "Createchannelaccount",
                component: Createchannelaccount,
            },
            {
                path: "Contactslist",
                name: "ChannelContactsList",
                component: ChannelContactsList,
            },
            {
                path: "createContacts/:id?",
                name: "CreateChannelContacts",
                component: CreateChannelContacts,
            },
            {
                path: "credituselinelist",
                name: "credituselineList",
                component: credituselineList,
            },

        ],
    },
    {
        path: "/shopcart",
        component: getViews("shopMain"),
        children: [{
            path: "list",
            name: "ShoppingCartList",
            component: ShoppingCartList,
        }, ],
    },
    {
        path: "/confirm",
        component: getProductViews("OrderConfirm"),
        children: [{
            path: ":id/order",
            name: "OrderConfirm",
            component: OrderConfirm,
        }, ],
    },
    {
        path: "/quickorder",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "QuickOrderList",
                component: QuickOrderList,
            }, ,
            {
                path: "importproduct",
                meta: {
                    keepAlive: true,
                    allowAnonymous: true,
                },
                component: ShoppingMallImportProduct,
            },
        ],
    },
    {
        path: "/contract",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "ContractList",
                component: ContractList,
            },
            {
                path: "view/:id",
                name: "ContractView",
                component: ContractView,
            },
        ],
    },
    {
        path: "/proprice",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "ProPriceList",
                component: ProPriceList,
            },
            {
                path: "create",
                name: "ProPriceCreate",
                component: ProPriceView,
            },
            {
                path: "view/:id",
                name: "proprice-detail",
                component: ProPriceView,
            },
        ],
    },
    {
        path: "/salesforecast",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "ForecastList",
                component: ForecastList,
            },
            {
                path: "view/:id",
                name: "ForecastView",
                component: ForecastView,
            },
            {
                path: "create",
                name: "ForecastCreate",
                component: ForecastView,
            },
            {
                path: "report",
                name: "ForcecastReport",
                component: ForcecastReport,
            },
        ],
    },
    {
        path: "/filedownload",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "FileDownloadList",
                component: FileDownloadList,
            },
            {
                path: "view/:id",
                name: "FileDownloadView",
                component: FileDownloadView,
            },
        ],
    },
    {
        path: "/salesman",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "SalesmanList",
                component: SalesmanList,
            },
            {
                path: "Edit/:id",
                name: "SalesmanEdit",
                component: SalesmanEdit,
            },
            {
                path: "view",
                name: "SalesmanView",
                component: SalesmanView,
            },
        ],
    },
    {
        path: "/opportunity",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "OpportunityList",
                component: OpportunityList,
            },
            // {
            //     path: "edit/:id?/:channeltype?",
            //     name: "OpportunityEdit",
            //     component: OpportunityEdit,
            // },
            {
                path: "create/:id?",
                name: "CreateOpportunity",
                component: CreateOpportunity,
            },
            {
                path: "createDomestic/:id?/:channeltype?",
                alias: "edit/:id",
                name: "CreateOpportunityDomestic",
                component: CreateOpportunityDomestic,
            },
            {
                path: "detailedit/:id/:type",
                name: "DetailEdit",
                component: DetailEdit,
            },
            {
                path: "adddetailedit/:id?/:type?",
                name: "AddDetailEdit",
                component: AddDetailEdit,
            },
            {
                path: "detaileditportal/:id/:type/:priceid",
                name: "DetailEditPortal",
                component: DetailEditPortal,
            },
            {
                //续保
                path: "detailcontinueediteditportal/:id",
                name: "DetailContinueeditEditPortal",
                component: DetailContinueeditEditPortal,
            },
        ],
    },
    {
        path: "/channelopportunity",
        alias: "/new_channelopportunity",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "channelOpportunityList",
                component: ChannelOpportunityList,
            },
            // {
            //     path: "edit/:id?",
            //     name: "channelOpportunityEdit",
            //     component: ChannelOpportunityEdit,
            // },
            {
                path: "create",
                name: "channelCreateOpportunity",
                component: ChannelCreateOpportunity,
            },
            {
                path: "createDomestic/:id?/:channeltype?",
                alias: "edit/:id?/:channeltype?",
                name: "channelCreateOpportunityDomestic",
                component: ChannelCreateOpportunityDomestic,
            },
            {
                path: "detailedit/:id/:type",
                name: "channelDetailEdit",
                component: ChannelDetailEdit,
            },
            {
                path: "detaileditportal/:id/:type/:priceid",
                name: "channelDetailEditPortal",
                component: ChannelDetailEditPortal,
            },
        ],
    },
    {
        path: "/quotacrm",
        component: CRM,
        children: [{
            path: "detailedit/:id/:type/:priceid",
            name: "crm__detailedit",
            component: DetailEdit,
        }, ],
    },
    {
        path: "/testmachinecrm",
        component: CRM,
        children: [
            {
                path: "detailedit/:id/:type/:priceid",
                name: "crm__TestMachineDetailEdit",
                component: TestMachineDetailEdit,
            },
            {
                path: "detaileditTwo/:id/:type/:priceid/:quoteid",
                name: "crm__testmachinedetailTwoEdit",
                component: testmachinedetailTwoEdit,
            },
        ],
    },
    {
        path: "/opportunitycrm",
        component: CRM,
        children: [{
                path: "adddetailedit/:id?/:type?",
                name: "crm__AddDetailEdit",
                component: AddDetailEdit,
            },
            {
                path: "addleaddetailedit/:id?/:type?",
                name: "crm__AddLeadDetailEdit",
                component: AddLeadDetailEdit,
            },
            //add wangke 230829 增加续保路由 从CRM打开 begin
            {
                path: "continueedit/:id?",
                name: "crm__continueedit",
                component: ContinueEdit,
            },
            {
                path: "continueeimportdit/:id?",
                name: "crm__continueeimportdit",
                component: Continueeimportdit,
            },
            //add wangke 230829 增加续保路由 从CRM打开 begin
        ],
    },
    {
        path: "/resissueapplication",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "ResissueApplicationList",
                component: ResissueApplicationList,
            },
            {
                path: "detail/:id",
                name: "ResissueApplicationDetail",
                component: ResissueApplicationDetail,
            },
        ],
    },
    {
        path: "/comparison",
        component: Main1,
        children: [{
                path: "list",
                name: "comparisonList",
                component: ComparisonList,
                meta: {
                    keepAlive: true, // 需要被缓存
                },
            },
            {
                path: "view",
                name: "comparisonView",
                component: ComparisonView,
            },
        ],
    },
    {
        path: "/comparisoncrm",
        component: Main3,
        children: [{
                path: "list",
                name: "crm__comparisonList",
                component: ComparisonList,
                meta: {
                    keepAlive: true, // 需要被缓存
                },
            },
            {
                path: "view",
                name: "crm__comparisonView",
                component: ComparisonView,
            },
        ],
    },
    {
        path: "/tempcredit",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "TempcreditList",
                component: TempcreditList,
            },
            {
                path: "view/:id",
                name: "tempcredit-detail",
                component: TempcreditView,
            },
            {
                path: "create",
                name: "TempcreditCreate",
                component: TempcreditView,
            },
        ],
    },
    {
        path: "/costapply",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "CostapplyList",
                component: CostapplyList,
            },
            {
                path: "view/:id",
                name: "costapply-detail",
                component: CostapplyView,
            },
            {
                path: "create",
                name: "CostapplyCreate",
                component: CostapplyView,
            },
        ],
    },
    {
        path: "/rebatedetail",
        component: getViews("Main"),
        children: [{
            path: "list",
            name: "RebatedetailList",
            component: RebatedetailList,
        }, ],
    },
    {
        path: "/accountstatementlist",
        component: getViews("Main"),
        children: [{
            path: "list",
            name: "accountstatementList",
            component: AccountStatementList,
        }, ],
    },
    {
        path: "/accountstatementDetail/:id/:date",
        component: getViews("Main"),
        children: [{
            path: "detail",
            name: "accountstatement-detail",
            component: AccountStatementDetail,
        }, ],
    },
    {
        path: "/resetpassword",
        component: getViews("Main"),
        children: [{
            path: "view",
            name: "resetpassword-view",
            component: ResetPasswordView,
        }, ],
    },
    //配置报价
    {
        path: "/quotationconfig/list",
        name: "quotationconfiglist",
        meta: {
            allowAnonymous: true,
        },
        component: QuotationConfigList,
    },
    {
        path: "/quotationconfig/create/:quoteId?",
        name: "quotationconfigcreate",
        meta: {
            allowAnonymous: true,
        },
        component: QuotationConfigDetail,
    },
    {
        path: "/quotationconfig/edit/:quoteId?/:cpqQuoteId?",
        name: "quotationconfigedit",
        meta: {
            allowAnonymous: true,
        },
        component: QuotationConfigDetail,
    },
    {
        path: "/quote/details/:cpqQuoteId?",
        name: "quotedetails",
        meta: {
            allowAnonymous: true,
        },
        component: QuoteDetails,
    },
    {
        path: "/product/catalog",
        name: "productcatalog",
        meta: {
            allowAnonymous: true,
        },
        component: productCatalogIndex,
    },
    {
        path: "/collect/list",
        name: "collectlist",
        meta: {
            allowAnonymous: true,
        },
        component: collectList,
    },
    {
        path: "/config/page",
        name: "configpage",
        meta: {
            allowAnonymous: true,
        },
        component: vehicleVarConfigList,
    },
    {
        path: "/config/linepage",
        name: "configlinepage",
        // meta: {
        //   allowAnonymous: true,
        // },
        component: contractConfigList,
    },
    {
        path: "/pricebook", //价格手册
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "priceBookList",
                component: priceBookList,
            },
            {
                path: "detail/:id",
                name: "priceBookDetail",
                component: priceBookDetail,
            },
        ],
    },
    {
        path: "/quotation",
        component: CRM,
        children: [
            //山石/渠道   价格修改
            {
                path: "quotationdetailPrice/:quototionid?/:entityType?",
                name: "crm__quotationdetailPrice",
                component: quotationdetailPriceEdit,
            },
        ],
    },
    {
        path: "/agentsnapshot", //代理商业绩快照
        component: getViews("Main"),
        children: [{
            path: "list",
            name: "agentsnapshotList",
            meta: {
                allowAnonymous: true,
            },
            component: AgentSnapShotList,
        }, ],
    },
    {
        path: "/agentsnapshot", //代理商业绩快照报表
        component: getViews("Main"),
        children: [{
            path: "report",
            name: "agentsnapshotReport",
            meta: {
                allowAnonymous: true,
            },
            component: AgentSnapShotReport,
        }, ],
    },
    {
        path: "/distributorPerformancesnapShot", //二代代理商业绩快照报表
        component: getViews("Main"),
        children: [{
            path: "report",
            name: "distributorPerformancesnapShotReport",
            meta: {
                allowAnonymous: true,
            },
            component: DistributorPerformancesnapShotReport,
        }, ],
    },
    {
        path: "/quotation", //报价单
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "quotationList",
                meta: {
                    allowAnonymous: true,
                },
                component: quotationList,
            },
            //山石报价
            {
                path: "create/:id?",
                name: "CreateQuotation",
                component: CreateQuotation,
            },
            //（山石/渠道）报价添加明细
            {
                path: "quotationdetaileditportal/:id?/:type?/:priceid?",
                name: "quotationdetailedit-portal",
                component: quotationdetailEdit,
            },
            //渠道报价
            {
                path: "channelquota/:id?",
                name: "channelQuotation-edit",
                component: channelQuotationEdit,
            },
            //山石/渠道   价格修改
            {
                path: "quotationdetailPrice/:quototionid?/:entityType?",
                name: "quotationdetailPrice-edit",
                component: quotationdetailPriceEdit,
            },
            {
                path: "quotedetail/:id?/:approvalstatus?",
                name: "quotedetail-edit",
                component: quotedetailEdit,
            },
        ]
    },
    {
        path: "/testmachine", //测试机
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "testmachineList",
                component: testmachineList,
            },
            {
                path: "create/:id",
                name: "Createtestmachine",
                component: Createtestmachine,
            },
            {
                path: "createdetails",
                name: "BorrowfacilityView",
                component: BorrowfacilityView,
            },
        ],
    },
    {
        path: "/qrcode", //二维码
        component: CRM,
        children: [{
                path: "applyedit/:id/:name", //报名
                name: "ApplyEditor",
                meta: {
                    allowAnonymous: true,
                },
                component: CampaignApply,
            },
            {
                path: "signinedit/:id/:name", //签到
                name: "SigninEditor",
                meta: {
                    allowAnonymous: true,
                },
                component: CampaignSignin,
            },
            {
                path: "feedbackedit/:id/:name", //调查
                name: "Feedbackeditor",
                meta: {
                    allowAnonymous: true,
                },
                component: CampaignFeedback,
            },
            {
                path: "submitok",
                name: "MsgSubmitOk",
                meta: {
                    allowAnonymous: true,
                },
                component: SubmitOk,
            },
        ],
    },

    //银行流水
    {
        path: "/new_bankinfo",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "new_bankinfo-list",
                component: new_bankinfoList,
            },
            {
                path: "edit/:id",
                name: "new_bankinfo-edit",
                component: new_bankinfoEdit,
            },
            {
                path: "detailedit/:id",
                name: "new_ord_invoicelineEdit-edit",
                component: new_ord_invoicelineEdit,
            },
        ],
    },

    //渠道开票
    {
        path: "/new_channel_invoice",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "new_channel_invoice-list",
                component: new_channel_invoiceList,
            },
            {
                path: "edit/:id?",
                name: "new_channel_invoice-edit",
                component: new_channel_invoiceEdit,
            },
            {
                path: "detailedit/:id?/:mainId?",
                name: "new_channel_invoicelineEdit-edit",
                component: new_channel_invoicelineEdit,
            },
        ],
    },

    {
        path: "/new_waititem",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "new_waititem-list",
                component: () =>
                    import ('@/module/new_waititem/new_waititemList.vue')
            },
            {
                path: "edit/:id?",
                name: "new_waititem-edit",
                component: () =>
                    import ('@/module/new_waititem/new_waititemEdit.vue')
            },

        ],

    },

    //发货单
    {
        path: "/new_ord_shipment",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "new_ord_shipment-list",
                component: new_ord_shipmentList,
            },
            {
                path: "edit/:id",
                name: "new_ord_shipment-edit",
                component: new_ord_shipmentEdit,
            },
            // {
            //   path: "channelshipment",
            //   name: "new_ord_shipmentline-channel",
            //   component: channelshipment,
            // },
            // {
            //   path: "channelshipmentedit",
            //   name: "new_channel_shipment-edit",
            //   component: new_channel_shipmentEdit,
            // },
        ],
    },
    //发货明细
    {
        path: "/new_ord_shipmentline",
        component: getViews("Main"),
        children: [{
                path: "list",
                name: "new_ord_shipmentline-list",
                component: new_ord_shipmentlineList,
            },
            {
                path: "edit/:id",
                name: "new_ord_shipmentline-edit",
                component: new_ord_shipmentlineEdit,
            },
        ],
    },
    //渠道发货
    {
        path: "/new_channel_shipment",
        component: getViews("Main"),
        children: [{
            path: "edit/:id",
            name: "new_channel_shipment-edit",
            component: new_channel_shipmentEdit,
        }, ],
    },
    //渠道发货明细
    {
        path: "/new_channel_shipmentline",
        component: getViews("Main"),
        children: [{
            path: "edit/:id",
            name: "new_channel_shipmentline-edit",
            component: new_channel_shipmentlineEdit,
        }, ],
    },



];
import store from "../store";

function getViews(path) {
    const isStore = store.state.isStore;
    if (isStore) {
        return (resolve) =>
            require(["@/components/main/" + path + ".vue"], resolve);
    } else {
        return (resolve) => require(["@/components/main/Main1.vue"], resolve);
    }
}

function getProductViews(path) {
    const isStore = store.state.isStore;
    if (isStore) {
        return (resolve) =>
            require(["@/module/quickorder/" + path + ".vue"], resolve);
    } else {
        return (resolve) => require(["@/components/main/Main1.vue"], resolve);
    }
}


// WEBPACK FOOTER //
// ./src/module/router.js